import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faPlus, faSearch } from '@fortawesome/free-solid-svg-icons';
import './DataTable.css';

const DataTable = ({ 
  title, 
  columns, 
  data, 
  onAdd, 
  onEdit, 
  onDelete, 
  onSearch,
  loading 
}) => {
  return (
    <div className="data-table-container">
      <div className="data-table-header">
        <h2 className="data-table-title">{title}</h2>
        <div className="data-table-actions">
          {onSearch && (
            <div className="search-wrapper">
              <input 
                type="text" 
                placeholder="Rechercher..." 
                className="search-input"
                onChange={(e) => onSearch(e.target.value)}
              />
            </div>
          )}
          {onAdd && (
            <button className="btn btn-primary" onClick={onAdd}>
              <FontAwesomeIcon icon={faPlus} style={{ marginRight: '0.5rem' }} />
              Ajouter
            </button>
          )}
        </div>
      </div>

      <div className="table-wrapper">
        <table className="data-table">
          <thead>
            <tr>
              {columns.map((col, index) => (
                <th key={index}>{col.header}</th>
              ))}
              {(onEdit || onDelete) && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={columns.length + 1} style={{ textAlign: 'center', padding: '2rem' }}>
                  Chargement...
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan={columns.length + 1} style={{ textAlign: 'center', padding: '2rem' }}>
                  Aucune donnée trouvée
                </td>
              </tr>
            ) : (
              data.map((item, rowIndex) => (
                <tr key={item.id || rowIndex}>
                  {columns.map((col, colIndex) => (
                    <td key={colIndex}>
                      {col.render ? col.render(item) : item[col.accessor]}
                    </td>
                  ))}
                  {(onEdit || onDelete) && (
                    <td>
                      <div style={{ display: 'flex', gap: '0.5rem' }}>
                        {onEdit && (
                          <button className="action-btn" onClick={() => onEdit(item)}>
                            <FontAwesomeIcon icon={faEdit} />
                          </button>
                        )}
                        {onDelete && (
                          <button className="action-btn delete" onClick={() => onDelete(item)}>
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        )}
                      </div>
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DataTable;
